/**
 * 目录 volArray 卷号解析（CJS，供 Node 单测与 Vue 共用）
 */

function parseVolNumFromTitleString(title) {
  if (!title) return null
  const match = String(title).match(/第(\d+)卷/)
  return match ? parseInt(match[1], 10) : null
}

function resolveCatalogVolNum(vol, index) {
  if (typeof vol === 'number' && !Number.isNaN(vol)) {
    return vol
  }
  if (vol && typeof vol === 'object') {
    if (vol.num != null && vol.num !== '') {
      return Number(vol.num)
    }
    if (vol.volNum != null && vol.volNum !== '') {
      return Number(vol.volNum)
    }
    const fromTitle = parseVolNumFromTitleString(vol.title)
    if (fromTitle != null) {
      return fromTitle
    }
    if (index != null && index >= 0) {
      return index + 1
    }
    return 1
  }
  const fromTitle = parseVolNumFromTitleString(vol)
  if (fromTitle != null) {
    return fromTitle
  }
  if (index != null && index >= 0) {
    return index + 1
  }
  return 1
}

function applyGuestCatalogProgressPolicy(volArray, hasToken) {
  if (hasToken || !volArray?.length) {
    return volArray
  }
  volArray.forEach((vol, index) => {
    const volNum = resolveCatalogVolNum(vol, index)
    const blocked = vol?.accessStatus === 'NEED_LOGIN' || (!vol?.accessStatus && volNum > 1)
    if (blocked) {
      vol.progress = 0
      vol.pageIndex = null
    }
  })
  return volArray
}

module.exports = {
  parseVolNumFromTitleString,
  resolveCatalogVolNum,
  applyGuestCatalogProgressPolicy,
}
